import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ConfigProvider, message as antdMessage } from 'antd';
import enUS from 'antd/es/locale/en_US';
import zhCN from 'antd/es/locale/zh_CN';

export const LANGUAGE_STORAGE_KEY = 'pz-language';

const englishMessages = {
    '中文': '中文',
    'English': 'English',
    '帮助': 'Help',
    '首页': 'Home',
    '房产市场': 'Real Estate',
    '饰品交易市场': 'Marketplace',
    '我的库存': 'My Inventory',
    '我的出售': 'My Sales',
    '我的购买': 'My Purchases',
    '个人中心': 'Account',
    '注册/登录': 'Sign up / Log in',
    '登录/注册': 'Log in / Sign up',
    '手机验证码登录认证': 'SMS Verification',
    '注册': 'Sign Up',
    '忘记密码': 'Forgot Password',
    '请输入手机号': 'Enter phone number',
    '请输入六位数令牌验证码': 'Enter 6-digit authenticator code',
    '请输入验证码': 'Enter verification code',
    '发送验证码': 'Send Code',
    '重新发送': 'Resend',
    '发送成功': 'Code sent.',
    '登录成功': 'Logged in successfully.',
    '您输入的手机号有误': 'Enter a valid phone number.',
    '您输入的验证码有误': 'Enter a valid verification code.',
    '您输入的验证码格式有误': 'The verification code format is invalid.',
    '您输入的令牌验证码有误': 'Enter a valid authenticator code.',
    '组件加载失败': 'The verification component failed to load.',
    '通过': 'Verified',
    '人机滑块验证': 'Complete Security Verification',
    '下一步': 'Next',
    '设置密码': 'Set Password',
    '请输入密码': 'Enter password',
    '再次输入密码': 'Enter password again',
    '邀请码(选填)': 'Referral Code (Optional)',
    '输入邀请码': 'Enter referral code',
    '密码要大于8位': 'Password must be longer than 8 characters.',
    '请勿输出非法字符！': 'The password contains unsupported characters.',
    '两次输入的密码不一致': 'The passwords do not match.',
    '密码修改成功': 'Password updated successfully.',
    '密码修改成功，3秒后跳转登录': 'Password updated. Redirecting to login in 3 seconds.',
    '注册成功': 'Registration successful.',
    '注册成功，3秒后跳转登录': 'Registration successful. Redirecting to login in 3 seconds.',
    '格式不正确！': 'The format is invalid.',
    '请正确输入渐变区间': 'Enter a valid fade range.',
    '请填写完整所需要的信息!': 'Complete all required information.',
    '请选择款式信息!': 'Select a style.',
    '求购单价需要大于等于{{price}}！': 'The buy-order unit price must be at least {{price}}.',
    '发布成功！': 'Published successfully.',
    '包含物品': 'Included Items',
    '收藏品总览': 'Collection Overview',
    '此武器箱包含以下物品': 'This case contains the following items',
    '价格区间：': 'Price Range:',
    '价格：': 'Price:',
    '武器箱收藏品': 'Case Collections',
    '地图收藏品': 'Map Collections',
    '保留7天登录状态': 'Keep me signed in for 7 days',
    '我同意': 'I agree to the',
    '《隐私政策》': 'Privacy Policy',
    '《用户协议》': 'Terms of Service',
    '和': ' and ',
    '注销': 'Log out',
    '店铺': 'Store',
    '余额': 'Balance',
    '充值': 'Deposit',
    '提现': 'Withdraw',
    '关于我们': 'About Us',
    '用户协议': 'Terms of Service',
    '隐私政策': 'Privacy Policy',
    'PZ服务': 'PZ Services',
    'APP下载': 'Download App',
    '健康游戏公告： 抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活': 'Healthy gaming notice: Reject harmful and pirated games, protect yourself from scams, and play responsibly.',
    'PZ饰品交易平台': 'PZ Item Marketplace',
    '支持DOTA2，CSGO等热门游戏': 'Supports popular games including Dota 2 and CS2',
    '下载': 'Download',
    '暂时无法下载IOS App！': 'The iOS app is not available yet.',
    'steam库存': 'Steam Inventory',
    'Steam库存': 'Steam Inventory',
    'CSGO饰品': 'CS2 Items',
    'DOTA2饰品': 'Dota 2 Items',
    '前往公开Steam库存': 'Open Steam inventory privacy settings',
    '背包取回记录': 'Backpack Retrieval History',
    '购物金（不可提现）': 'Store Credit (non-withdrawable)',
    'MOE代币': 'MOE Tokens',
    '自售管理': 'Listings',
    '出售记录': 'Sales History',
    '自售购买': 'Purchases',
    '购买记录': 'Purchase History',
    '自售中': 'Active Listings',
    '等待发货': 'Awaiting Shipment',
    '一键发送报价': 'Send All Offers',
    '一键发送报价注意事项：': 'Send All Offers — Important Notes:',
    '1.发送过程约2分钟，请耐心等待；': '1. Sending offers takes about two minutes. Please wait patiently.',
    '2.需要用户自行刷新页面查看订单变化；': '2. Refresh this page manually to see order updates.',
    '3.如果发现订单未发送报价的情况，请参考以下情况：': '3. If an offer was not sent, check the following:',
    '3-1.检查与对方的交易报价是否过多': '3-1. Check whether there are too many active trade offers with the buyer.',
    '3-2.Steam游戏物品服务器可能处于停机状态，或者 Steam 可能暂时遇到连接问题。请稍后再试。': '3-2. Steam item servers may be down or temporarily unavailable. Try again later.',
    '3-3.当前卖家是否已经绑定了 Steam 手机令牌并大于 15 天 ！': '3-3. Make sure the seller has had Steam Mobile Authenticator enabled for more than 15 days.',
    '订单号(验证码)': 'Order No. (Code)',
    '订单号': 'Order No.',
    '饰品名称': 'Item',
    '订单金额': 'Order Total',
    '购买时间': 'Purchased At',
    '订单完成时间': 'Completed At',
    '买家信息': 'Buyer',
    '交易状态': 'Status',
    '注册时间': 'Registered',
    '磨损': 'Float',
    '查看买家 Steam 主页': 'View Buyer Steam Profile',
    '取消订单': 'Cancel Order',
    '取消报价': 'Cancel Offer',
    '取消报价成功': 'Offer cancelled successfully.',
    '卖家报价验证': 'Verify Seller Offer',
    '发送报价': 'Send Offer',
    '共': 'Total ',
    '件': ' items',
    '总价值：': 'Total Value: ',
    '总参考价：': 'Total Reference: ',
    '搜索': 'Search',
    '请输入物品名称': 'Enter item name',
    '按价格': 'Price',
    '按时间': 'Time',
    '最低价': 'Min price',
    '最高价': 'Max price',
    '请输入订单号': 'Enter order number',
    '重置': 'Reset',
    '筛选': 'Filter',
    '正在加载 ...': 'Loading ...',
    '还有库存正在加载中....': 'More inventory is loading...',
    '刷新': 'Refresh',
    '全选': 'Select All',
    '已选择：': 'Selected: ',
    '库存估值：': 'Inventory Value: ',
    '件数：': 'Items: ',
    '一键解析当页物品': 'Analyze Items on This Page',
    '自售上架': 'List for Sale',
    '上架': 'List',
    '改价': 'Change Price',
    '下架物品': 'Delist Items',
    '上架成功': 'Listed successfully',
    '下架成功': 'Delisted successfully',
    '改价成功': 'Price updated',
    '请输入正确金额': 'Enter a valid price',
    '请勾选要上架的物品': 'Select items to list',
    '暂无': 'N/A',
    '未知': 'Unknown',
    '查看买家Steam主页': 'View Buyer Steam Profile',
    '暂无数据': 'No data',
    '数量': 'Quantity',
    '手续费': 'Fee',
    '创建时间': 'Created At',
    '操作': 'Actions',
    '查看详情': 'View Details',
    '购买': 'Buy',
    '求购': 'Buy Order',
    '发起求购': 'Create Buy Order',
    '求购中': 'Active Buy Orders',
    '求购记录': 'Buy Order History',
    '出售中': 'For Sale',
    '饰品种类': 'Item Type',
    '品质': 'Quality',
    '外观': 'Exterior',
    '类别': 'Category',
    '收藏品': 'Collection',
    '显示全部': 'Show All',
    '显示可交易': 'Tradable',
    '显示可出售': 'Marketable',
    '不限': 'All',
    '匕首': 'Knives',
    '手枪': 'Pistols',
    '步枪': 'Rifles',
    '微型冲锋枪': 'SMGs',
    '散弹枪': 'Shotguns',
    '机枪': 'Machine Guns',
    '手套': 'Gloves',
    '印花': 'Stickers',
    '探员': 'Agents',
    '其他': 'Other',
    '折叠刀': 'Flip Knife',
    '穿肠刀': 'Gut Knife',
    '刺刀': 'Bayonet',
    'M9刺刀': 'M9 Bayonet',
    '爪子刀': 'Karambit',
    '蝴蝶刀': 'Butterfly Knife',
    '弯刀': 'Falchion Knife',
    '暗影双匕': 'Shadow Daggers',
    '鲍伊猎刀': 'Bowie Knife',
    '短剑': 'Stiletto Knife',
    '熊刀': 'Ursus Knife',
    '折刀': 'Navaja Knife',
    '锯齿爪刀': 'Talon Knife',
    '海豹短刀': 'Classic Knife',
    '骷髅匕首': 'Skeleton Knife',
    '系绳匕首': 'Paracord Knife',
    '求生匕首': 'Survival Knife',
    '流浪者匕首': 'Nomad Knife',
    '猎杀者匕首': 'Huntsman Knife',
    'USP 消音版': 'USP-S',
    '格洛克 18 型': 'Glock-18',
    'CZ75 自动手枪': 'CZ75-Auto',
    '沙漠之鹰': 'Desert Eagle',
    'R8 左轮手枪': 'R8 Revolver',
    '双持贝瑞塔': 'Dual Berettas',
    '法玛斯': 'FAMAS',
    '加利尔 AR': 'Galil AR',
    'M4A1 消音型': 'M4A1-S',
    'PP-野牛': 'PP-Bizon',
    '新星': 'Nova',
    '截短霰弹枪': 'Sawed-Off',
    '内格夫': 'Negev',
    '血猎手套': 'Bloodhound Gloves',
    '驾驶手套': 'Driver Gloves',
    '裹手': 'Hand Wraps',
    '摩托手套': 'Moto Gloves',
    '专业手套': 'Specialist Gloves',
    '运动手套': 'Sport Gloves',
    '九头蛇手套': 'Hydra Gloves',
    '狂牙手套': 'Broken Fang Gloves',
    '参考价': 'Reference Price',
    '售价': 'Price',
    '需求': 'wanted',
    '在售': 'listed',
    '{{count}} 件在售': '{{count}} listed',
    '{{count}} 件需求': '{{count}} wanted',
    '崭新出厂': 'Factory New',
    '略有磨损': 'Minimal Wear',
    '久经沙场': 'Field-Tested',
    '破损不堪': 'Well-Worn',
    '战痕累累': 'Battle-Scarred',
    '无涂装': 'Not Painted',
    '换货锁定': 'Exchange Locked',
    '供应中': 'Supplying',
    '付款': 'Pay',
    '复制成功': 'Copied',
    '请先登录！': 'Please log in first.',
    '请先完善Steam绑定！': 'Please connect your Steam account first.',
    '请先绑定 steam 交易链接！': 'Please add your Steam trade URL first.',
    '请先绑定 ApiKey!': 'Please add your Steam API key first.',
    '取消中...': 'Cancelling...',
    '订单效验成功！': 'Order verified.'
    ,
    '账户设置': 'Account Settings'
    ,
    '我的钱包': 'My Wallet'
    ,
    '关注饰品': 'Watchlist'
    ,
    '我的消息': 'Messages'
    ,
    '联系客服': 'Customer Support'
    ,
    '账号基本设置': 'Basic Account Settings'
    ,
    '修改用户名': 'Change Username'
    ,
    '确认': 'Confirm'
    ,
    '取消': 'Cancel'
    ,
    '请输入用户名': 'Enter username'
    ,
    '昵称长度需要在1到14位之间！': 'Nickname must be between 1 and 14 characters.'
    ,
    '昵称必须在1到14个字符以内，可以包含数字、英文、中文，三个月内只能修改一次。(请勿带有辱骂、广告、诱导等其他违反法规的词汇，违者帐号将被封禁处理)': 'Nicknames must be 1–14 characters and may contain numbers, English letters, and Chinese characters. They can only be changed once every three months. Do not use abusive, promotional, misleading, or otherwise unlawful language; violations may result in account suspension.'
    ,
    '请先绑定手机号': 'Connect your phone number first.'
    ,
    '修改成功！': 'Updated successfully.'
    ,
    '修改成功': 'Updated successfully.'
    ,
    '账号信息设置': 'Personal Information'
    ,
    '手机号': 'Phone Number'
    ,
    '已绑定': 'Connected'
    ,
    '未绑定': 'Not Connected'
    ,
    '绑定手机号': 'Connected Phone'
    ,
    '更换': 'Change'
    ,
    '绑定': 'Connect'
    ,
    '实名认证': 'Identity Verification'
    ,
    '已认证': 'Verified'
    ,
    '实名认证填写身份证': 'Verify your identity with an ID document'
    ,
    '认证': 'Verify'
    ,
    '真实姓名': 'Legal Name'
    ,
    '身份证号': 'ID Number'
    ,
    '支付宝账号': 'Alipay Account'
    ,
    '输入邮箱': 'Enter Email'
    ,
    '支付宝身份验证(推荐)': 'Alipay Identity Verification (Recommended)'
    ,
    '邮箱格式有误': 'The email address format is invalid.'
    ,
    '请先同意用户协议和隐私政策': 'Please agree to the Terms of Service and Privacy Policy first.'
    ,
    '请把信息填写完整': 'Please complete all required information.'
    ,
    '请求超时，请稍后重试': 'The request timed out. Please try again later.'
    ,
    '姓名：{{name}}': 'Name: {{name}}'
    ,
    '身份证号：{{id}}': 'ID Number: {{id}}'
    ,
    '支付宝账号：{{account}}': 'Alipay Account: {{account}}'
    ,
    '请确认填写的姓名及身份证号是你本人的且正确无误，错误信息将导致认证不通过，非本人信息会影响网站功能使用（如提现）。': 'Confirm that the name and ID number are yours and are correct. Incorrect or third-party information may fail verification and restrict features such as withdrawals.'
    ,
    '信息仅用于支付宝身份验证。请确认填写的姓名、身份证号和支付宝账号是你本人的且正确无误，点击确认将跳转支付宝，请使用上方填写的支付宝账号进行登录验证，错误或者不匹配的信息将导致认证不通过。认证通过后，该支付宝账号将作为默认提现账号（可使用大额提现功能）。': 'This information is used only for Alipay identity verification. Confirm that the name, ID number, and Alipay account belong to you and are correct. After you continue to Alipay, sign in with the account entered above. Incorrect or mismatched information will fail verification. Once verified, this Alipay account becomes your default withdrawal account and can be used for large withdrawals.'
    ,
    '请使用支付宝扫描以下二维码进行人脸识别认证': 'Scan the QR code below with Alipay to complete facial verification.'
    ,
    '认证成功请手动刷新页面': 'After verification succeeds, refresh this page manually.'
    ,
    '修改密码：': 'Change Password:'
    ,
    '修改密码': 'Change Password'
    ,
    'APP在“我的”页面右上角设置中的“账号与安全”中修改': 'In the app, open Me, then Settings in the upper-right corner, and select Account & Security.'
    ,
    '电脑网页端在登录弹窗中选择使用密码验证登录后，点击忘记密码，进行修改': 'On the website, choose password sign-in in the login dialog, then click Forgot Password.'
    ,
    '个人信息用于实名认证，一旦认证不能修改，请认真填写。': 'This information is used for identity verification and cannot be changed after verification. Please enter it carefully.'
    ,
    '交易信息设置': 'Trade Settings'
    ,
    '切换Steam账号': 'Switch Steam Account'
    ,
    '点击下拉框选择需要换绑的 Steam 账号': 'Select the Steam account to use'
    ,
    '绑定新的 Steam 账号': 'Connect Another Steam Account'
    ,
    '解绑当前 Steam 账号': 'Disconnect Current Steam Account'
    ,
    '交易链接': 'Trade URL'
    ,
    '请输入交易链接': 'Enter Steam trade URL'
    ,
    '前往Steam获取': 'Get from Steam'
    ,
    '请输入您的STEAM API KEY': 'Enter your Steam API key'
    ,
    '保存': 'Save'
    ,
    '安全设置': 'Security Settings'
    ,
    '登录设备管理': 'Login Device Management'
    ,
    '查看': 'View'
    ,
    '流水记录': 'Transaction History'
    ,
    '可提现:': 'Withdrawable:'
    ,
    '不可提现:': 'Non-withdrawable:'
    ,
    '最后更新于': 'Last updated'
    ,
    '未找到该文档': 'Document not found'
    ,
    '提现小提示': 'Withdrawal Tips'
    ,
    '1.用户出售所得为可提现余额，只有可提现余额才能提现。': '1. Only proceeds from sales are withdrawable.'
    ,
    '收款账户': 'Payout Account'
    ,
    '推荐': 'Recommended'
    ,
    '银行:': 'Bank:'
    ,
    '卡号:': 'Card Number:'
    ,
    '收款人:': 'Recipient:'
    ,
    '支付宝账号：': 'Alipay Account:'
    ,
    '收款人：': 'Recipient:'
    ,
    '修改': 'Edit'
    ,
    '提现金额': 'Withdrawal Amount'
    ,
    '请输入提现金额': 'Enter withdrawal amount'
    ,
    '提现手续费': 'Withdrawal Fee'
    ,
    '实际到账': 'Net Amount'
    ,
    '确认提现': 'Confirm Withdrawal'
    ,
    '提现记录': 'Withdrawal History'
    ,
    '提现金额(元)': 'Withdrawal Amount (CNY)'
    ,
    '提现手续费(元)': 'Withdrawal Fee (CNY)'
    ,
    '提现时间': 'Withdrawal Time'
    ,
    '提现方式': 'Method'
    ,
    '进度': 'Status'
    ,
    '提现成功': 'Withdrawal Successful'
    ,
    '正在提现': 'Processing'
    ,
    '提现失败': 'Withdrawal Failed'
    ,
    '【支付宝】': 'Alipay'
    ,
    '【银行卡】': 'Bank Card'
    ,
    '充值金额': 'Deposit Amount'
    ,
    '输入金额': 'Enter amount'
    ,
    '充值方式': 'Payment Method'
    ,
    '确认充值': 'Confirm Deposit'
    ,
    '充值记录': 'Deposit History'
    ,
    '充值到账金额(元)': 'Credited Amount (CNY)'
    ,
    '充值手续费(元)': 'Deposit Fee (CNY)'
    ,
    '付款方式': 'Payment Method'
    ,
    '扫码支付': 'Scan to Pay'
    ,
    '余额类型': 'Balance Type'
    ,
    '变动方式': 'Transaction Type'
    ,
    '变动前余额(￥)': 'Balance Before (CNY)'
    ,
    '变动金额(￥)': 'Amount (CNY)'
    ,
    '变动后余额(￥)': 'Balance After (CNY)'
    ,
    '变动时间': 'Time'
    ,
    '购买退款': 'Purchase Refund'
    ,
    '充值退款': 'Deposit Refund'
    ,
    '销售所得': 'Sale Proceeds'
    ,
    '购买饰品': 'Item Purchase'
    ,
    '推广激励所得': 'Referral Reward'
    ,
    '背包所得': 'Backpack Proceeds'
    ,
    '求购扣款': 'Buy Order Charge'
    ,
    '发布求购': 'Create Buy Order'
    ,
    '取消求购': 'Buy Order Cancelled'
    ,
    '充值消费小提示': 'Deposit Tips'
    ,
    '1.单笔充值限额为10-20000元。': '1. Each deposit must be between CNY 10 and CNY 20,000.'
    ,
    '2.按照反洗钱政策，用户充值金额只能用于网站购买，不能直接提现。用户出售所得为可提现余额，可以提现至用户支付宝或者银行储蓄卡。': '2. Under anti-money-laundering rules, deposits can only be used for purchases and cannot be withdrawn directly. Sale proceeds may be withdrawn to Alipay or a bank card.'
    ,
    '3.违规资金将冻结处理。': '3. Funds associated with violations will be frozen.',
    '自售交易市场': 'Marketplace',
    '已关注': 'Following',
    '关注': 'Follow',
    '类型：': 'Type: ',
    '品质：': 'Quality: ',
    '类别：': 'Category: ',
    '稀有度：': 'Rarity: ',
    '参考价：': 'Reference Price: ',
    '7天均价：': '7-day Average: ',
    '查看steam': 'View on Steam',
    '我要求购': 'Create Buy Order',
    '我要出售': 'Sell This Item',
    '成交记录': 'Sales History',
    '磨损排行': 'Float Ranking',
    '价格趋势': 'Price Trend',
    '图案模板': 'Pattern Template',
    '图案模板编号': 'Pattern Index',
    '价格': 'Price',
    '过滤': 'Filter',
    '磨损度': 'Float Value',
    '卖家': 'Seller',
    '上架时间': 'Listed At',
    '操作(购买)': 'Buy',
    '磨损区间': 'Float Range',
    '自定义磨损区间': 'Custom Float Range'
    ,
    '提示': 'Notice'
    ,
    '确定': 'OK'
    ,
    '批量购买请前往MOBI平台APP进行操作，支持合并发报价功能': 'Use the MOBI app for bulk purchases and combined trade offers.'
    ,
    '切换为普通': 'Switch to Standard'
    ,
    '切换为纪念品': 'Switch to Souvenir'
    ,
    '切换为statTrak™': 'Switch to StatTrak™'
    ,
    '时间': 'Time'
    ,
    '支付订单': 'Payment'
    ,
    '支付成功': 'Payment Successful'
    ,
    '在库检测': 'Inventory Check'
    ,
    '是否检查该饰品存在于卖家库存?本功能每日可使用5次。查询有效性会因Steam网络波动受到影响。': 'Check whether this item is still in the seller inventory? This feature can be used five times per day and may be affected by Steam network conditions.'
    ,
    '该卖家只支持买家发送报价': 'This seller only accepts offers sent by the buyer'
    ,
    '商品详情': 'Item Details'
    ,
    '支付方式': 'Payment Method'
    ,
    '余额不足': 'Insufficient Balance'
    ,
    '前往充值': 'Deposit Funds'
    ,
    '应付款：': 'Amount Due: '
    ,
    '确认付款': 'Confirm Payment'
    ,
    '你付款后须5分钟内在MOBI APP发起报价,卖家须12小时内完成发货.': 'After payment, send the trade offer in the MOBI app within 5 minutes. The seller must deliver within 12 hours.'
    ,
    '出售': 'Sale'
    ,
    '排名': 'Rank'
    ,
    '款式筛选': 'Style'
    ,
    '自定义': 'Custom'
    ,
    '自定义渐变区间(%)': 'Custom Fade Range (%)'
    ,
    '渐变程度': 'Fade Percentage'
    ,
    '日数据': 'Daily'
    ,
    '周数据': 'Weekly'
    ,
    '月数据': 'Monthly'
    ,
    '六个月数据': 'Six Months'
    ,
    '普通': 'Standard'
    ,
    '纪念品': 'Souvenir'
    ,
    '非凡': 'Extraordinary'
    ,
    '隐秘': 'Covert'
    ,
    '普通级': 'Base Grade'
    ,
    '消费级': 'Consumer Grade'
    ,
    '违禁': 'Contraband'
    ,
    '奇异': 'Exotic'
    ,
    '保密': 'Classified'
    ,
    '卓越': 'Remarkable'
    ,
    '受限': 'Restricted'
    ,
    '高级': 'High Grade'
    ,
    '军规级': 'Mil-Spec Grade'
    ,
    '工业级': 'Industrial Grade'
    ,
    '求购饰品': 'Item'
    ,
    '求购最高价': 'Highest Buy Order'
    ,
    '在售最低价': 'Lowest Listing'
    ,
    '款式选择': 'Style'
    ,
    '求购单价': 'Unit Price'
    ,
    '求购数量': 'Quantity'
    ,
    '应付总额：': 'Total: '
    ,
    '确认求购': 'Confirm Buy Order'
    ,
    '解绑确认': 'Confirm Disconnection'
    ,
    '当前绑定账号信息：': 'Currently Connected Account:'
    ,
    'Steam昵称：': 'Steam Name: '
    ,
    '绑定确认': 'Confirm Connection'
    ,
    '输入验证码': 'Enter Verification Code'
    ,
    '确认绑定到这个steam账号吗？': 'Connect this Steam account?'
    ,
    '请进行安全确认，输入{{phone}}手机收到的验证码': 'For security verification, enter the code sent to {{phone}}.'
    ,
    '请先完善Steam绑定': 'Connect Steam First'
    ,
    '前往绑定': 'Connect Now'
    ,
    '前往个人中心的交易信息设置绑定Steam': 'Go to Trade Settings in Account to connect Steam.'
    ,
    '请先完成实名认证': 'Complete Identity Verification First'
    ,
    '前往认证': 'Verify Now'
    ,
    '前往个人中心的账号信息设置完成实名认证': 'Go to Personal Information in Account to complete identity verification.'
    ,
    '请先绑定Steam交易链接': 'Add Your Steam Trade URL First'
    ,
    '当前检测到您未绑定Steam交易链接，请先绑定': 'No Steam trade URL was found. Add one to continue.'
    ,
    '前往获取交易链接': 'Get Trade URL from Steam'
    ,
    '请先绑定ApiKey': 'Add Your Steam API Key First'
    ,
    '当前检测到您未设置ApiKey，请先设置': 'No Steam API key was found. Add one to continue.'
    ,
    '请输入您的Steam Api Key': 'Enter your Steam API key'
    ,
    '前往获取Api Key': 'Get API Key from Steam'
    ,
    '图片': 'Image'
    ,
    '描述': 'Description'
    ,
    '订单详情': 'Order Details'
    ,
    '预计支付：': 'Estimated Payment: '
    ,
    '预计收入：': 'Estimated Proceeds: '
    ,
    '实付金额': 'Amount Paid'
    ,
    '买家支付金额': 'Buyer Payment'
    ,
    '购买订单': 'Purchase Order'
    ,
    '元': ' CNY'
    ,
    '交易价格': 'Trade Price'
    ,
    '买家昵称': 'Buyer Name'
    ,
    '卖家昵称': 'Seller Name'
    ,
    '采购人': 'Purchaser'
    ,
    '采购人信息：': 'Purchaser Information:'
    ,
    '订单有误': 'The order is invalid.'
    ,
    '订单时间': 'Order Time'
    ,
    '买家报价验证': 'Verify Buyer Offer'
    ,
    '报价发送成功！': 'Trade offer sent successfully.'
    ,
    '报价正在发送中！约2分钟左右完成': 'The trade offer is being sent and should complete in about two minutes.'
    ,
    '暂无时间信息': 'No time information'
    ,
    '关于API key': 'About API Key'
    ,
    '创建API key需要Steam账号消费超过5美金。': 'Your Steam account must have spent more than USD 5 before you can create an API key.'
    ,
    '卖家直发交易需要卖家提供API key用于交易报价检测。 API key可查询和取消交易报价,但无法创建和接受交易报价。': 'Seller-delivered trades require an API key for offer verification. The key can read and cancel offers, but cannot create or accept them.'
    ,
    '获取步骤：': 'Steps:'
    ,
    '1.点击前往获取；': '1. Click Get from Steam.'
    ,
    '2.进入steam库存隐私设置页面，需要将隐私设置中的“我的个人资料”和“库存”设置为公开；': '2. On Steam Inventory Privacy Settings, set both My Profile and Inventory to Public.'
    ,
    '3.资料的公开可能会存在延迟。': '3. Steam privacy changes may take a short time to become visible.'
    ,
    '2.如果当前没有创建API key，随意输入一个域名，然后点击注册；如果当前已经有API key但是并非自己注册的，建议注销掉，重新注册；': '2. If no API key exists, enter a domain and register one. Revoke and recreate any key you did not create yourself.'
    ,
    '3.把API key复制粘贴到输入框，点击保存。': '3. Paste the API key into the field and click Save.'
    ,
    '如访问页面没有正常加载，请先下载加速器后重试': 'If the Steam page does not load, enable a network accelerator and try again.'
    ,
    '请先绑定steam账号': 'Connect your Steam account first.'
    ,
    '您输入的信息有误': 'The information entered is invalid.'
    ,
    '您输入的 ApiKey 格式有误': 'The API key format is invalid.'
    ,
    '无效的 ApiKey!': 'Invalid API key.'
    ,
    '设置成功': 'Saved successfully.'
    ,
    '切换成功': 'Steam account switched.'
    ,
    '该账号暂时无法绑定 Steam！': 'This account cannot connect to Steam at this time.'
    ,
    '请直接注销登录！': 'Please log out directly.'
    ,
    '您必须使用手机验证码登录，才可进行当前操作！': 'Sign in with an SMS verification code to continue.'
    ,
    '已失败': 'Failed'
    ,
    '已取消': 'Cancelled'
    ,
    '待接单': 'Awaiting acceptance'
    ,
    '已接单 待买家付款': 'Accepted — awaiting buyer payment'
    ,
    '已付款 待卖家发货': 'Paid — awaiting seller delivery'
    ,
    '已发货 待收货': 'Delivered — awaiting receipt'
    ,
    '已收货 待打款': 'Received — awaiting payout'
    ,
    '订单已完成': 'Completed'
    ,
    '已下架': 'Delisted'
    ,
    '购买失败': 'Purchase failed'
    ,
    '出售失败': 'Sale failed'
    ,
    '报价发送中': 'Sending offer'
    ,
    '校验中...': 'Verifying...'
    ,
    '等待卖家steam令牌确认': 'Awaiting seller Steam Guard confirmation'
    ,
    '上架中': 'Listing'
    ,
    '已付款 待发货': 'Paid — awaiting delivery'
    ,
    '等待买家发起报价': 'Awaiting buyer trade offer'
    ,
    '等待卖家发起报价': 'Awaiting seller trade offer'
    ,
    '等待卖家回应报价': 'Awaiting seller response'
    ,
    '等待买家接受报价': 'Awaiting buyer acceptance'
    ,
    '购买成功': 'Purchase successful'
    ,
    '出售成功': 'Sale successful'
    ,
    '卖家已接受报价': 'Seller accepted the offer'
    ,
    '该报价已暂挂': 'Offer is on hold'
    ,
    '买家取消订单': 'Buyer cancelled the order'
    ,
    '买家拒绝报价': 'Buyer declined the trade offer'
    ,
    '卖家超时未发报价': 'Seller did not send the trade offer in time'
    ,
    '卖家超时未发送报价': 'Seller did not send the trade offer in time'
    ,
    '卖家拒绝了报价': 'Seller declined the trade offer'
    ,
    '卖家取消订单': 'Seller cancelled the order'
    ,
    '卖家取消报价': 'Seller cancelled the trade offer'
    ,
    '买家超时未接报价': 'Buyer did not accept the trade offer in time'
    ,
    '卖家物品不能用于交易': 'The seller item is not tradable'
    ,
    '饰品不在卖家库存！': 'The item is no longer in the seller inventory.'
    ,
    '违规操作，买家修改报价': 'Invalid action: the buyer modified the trade offer'
    ,
    '买家交易信息有误或无法交易(无法进行交易)': 'The buyer trade settings are invalid or trading is unavailable'
    ,
    '供应成功': 'Supply Successful'
    ,
    '交易补偿': 'Trade Compensation'
    ,
    '退款失败': 'Refund Failed'
    ,
    '协商退款': 'Negotiated Refund'
    ,
    '换货订单锁定金额': 'Exchange Order Funds Locked'
    ,
    '换货方案锁定金额': 'Exchange Plan Funds Locked'
    ,
    '饰品方案所得': 'Item Plan Proceeds'
    ,
    '换货订单金额退回': 'Exchange Order Funds Returned'
    ,
    '换货方案金额退回': 'Exchange Plan Funds Returned'
    ,
    '还价': 'Counteroffer'
    ,
    '还价失败': 'Counteroffer Failed'
    ,
    '其他所得': 'Other Proceeds'
    ,
    '[余额]': '[Balance]'
    ,
    '[其他余额]': '[Other Balance]'
    ,
    '[求购锁定余额]': '[Buy Order Funds Locked]'
    ,
    'MOBI余额': 'MOBI Balance'
    ,
    '求购锁定余额': 'Buy Order Funds Locked'
    ,
    '请求超时': 'Request timed out.'
    ,
    '用户需要在 PZ APP内重新登录steam!': 'Sign in to Steam again in the PZ app.'
    ,
    '如果你的库存无法正常刷新，请在MOBI App重新登录Steam，并稍后再试。': 'If your inventory cannot be refreshed, sign in to Steam again in the MOBI app and try later.'
    ,
    '您必须使用手机验证码登录，才可进行当前操作!': 'Sign in with an SMS verification code to continue.'
    ,
    '请求错误(400)': 'Bad request (400)'
    ,
    '登录过期，请重新登录': 'Your session has expired. Please sign in again.'
    ,
    '拒绝访问(403)': 'Access denied (403)'
    ,
    '请求出错(404)': 'Not found (404)'
    ,
    '服务器错误(500)': 'Server error (500)'
    ,
    '网络错误(502)': 'Network error (502)'
    ,
    '服务不可用(503)': 'Service unavailable (503)'
    ,
    '网络超时(504)': 'Network timeout (504)'
    ,
    '连接服务器失败!': 'Unable to connect to the server.'
    ,
    '当前余额不足！': 'Insufficient balance.'
    ,
    '退款': 'Refund'
    ,
    '支付失败': 'Payment Failed'
    ,
    '支付成功(已退款)': 'Payment Successful (Refunded)'
    ,
    '提示：': 'Details:'
    ,
    '退款到账金额:': 'Refund credited:'
    ,
    '退款手续费:': 'Refund fee:'
    ,
    '退款时间:': 'Refund time:'
    ,
    '等待支付': 'Awaiting Payment'
    ,
    '充值下单失败': 'Deposit Order Failed'
    ,
    '退款中...': 'Refunding...'
    ,
    '(支付宝账户)': ' (Alipay Account)'
    ,
    '(信用卡)': ' (Credit Card)'
    ,
    '(花呗)': ' (Huabei)'
    ,
    '【银联】': 'UnionPay'
    ,
    '【微信】': 'WeChat Pay'
    ,
    '(云闪付)': ' (QuickPass)'
    ,
    '(微信)': ' (WeChat)'
    ,
    '(支付宝)': ' (Alipay)'
    ,
    '(扫码支付)': ' (QR Code)'
    ,
    '(APP支付)': ' (App)'
    ,
    '订单超时已取消': 'The order timed out and was cancelled.'
    ,
    '充值成功，3秒后自动关闭弹窗': 'Deposit successful. This window will close in three seconds.'
    ,
    '正在使用即时到账交易 , 交易将在5分钟后关闭，请及时付款！': 'This instant-payment order closes in five minutes. Please complete payment promptly.'
    ,
    '请使用微信App进行扫码支付': 'Scan the QR code with the WeChat app.'
    ,
    '扫码支付:': 'QR Code Payment:'
    ,
    '正在检测...': 'Checking...'
    ,
    '我已充值': 'I Have Paid'
    ,
    '请将支付宝账号或收款人信息填写完整！': 'Enter both the Alipay account and recipient name.'
    ,
    '请将银行卡号或收款人信息填写完整！': 'Enter both the bank card number and recipient name.'
    ,
    '已保存！': 'Saved successfully.'
    ,
    '请先完善绑手机绑定！': 'Connect and verify your phone number first.'
    ,
    '请先完成实名认证！': 'Complete identity verification first.'
    ,
    '提现发起成功！等待处理': 'Withdrawal submitted and awaiting processing.'
    ,
    '可提现余额': 'Withdrawable Balance'
    ,
    '（单笔限额￥10000）': '(Limit: CNY 10,000 per withdrawal)'
    ,
    '登出成功': 'Signed out successfully.'
    ,
    '保存成功！': 'Saved successfully.'
    ,
    '移除成功！': 'Removed successfully.'
    ,
    '解锁成功！': 'Unlocked successfully.'
    ,
    '(本机)': '(This device)'
    ,
    '登出': 'Sign Out'
    ,
    '移除': 'Remove'
    ,
    '新增常用地': 'Add Trusted Location'
    ,
    '保存常用地': 'Save Trusted Location'
    ,
    '当前常用地：': 'Current Location:'
    ,
    '向 {{phone}} 发送验证码': 'Send a verification code to {{phone}}'
    ,
    '解锁密码登录': 'Unlock Password Login'
    ,
    '解锁': 'Unlock'
    ,
    '偏好设置': 'Preferences'
    ,
    '选择只让买家向我发送报价': 'Only allow buyers to send me trade offers'
    ,
    '允许买家还价': 'Allow buyers to make counteroffers'
    ,
    '推广码：': 'Referral Code:'
    ,
    '复制推广码': 'Copy Referral Code'
    ,
    '修改推广码': 'Change Referral Code'
    ,
    '我的推广链接：': 'My Referral Link:'
    ,
    '复制推广链接': 'Copy Referral Link'
    ,
    '更换推广人': 'Change Referrer'
    ,
    '请输入新推广码': 'Enter a new referral code'
    ,
    '请输入新推广人推广码': "Enter the new referrer's code"
    ,
    '修改成功!': 'Updated successfully!'
    ,
    '此项为修改用户自己的推广码，推广码必须6个字符，只能包含数字和大写英文字母，三个月内只能修改一次。': 'Your referral code must be 6 characters using only numbers and uppercase letters. It can be changed once every three months.'
    ,
    '此项为更换用户的推广人，更换成功之后之前的推广关系就会改变，请谨慎更换。用户推广人的推广码必须6个字符，只能包含数字和大写英文字母，三个月内只能更换一次。': "Changing your referrer replaces the existing referral relationship. The referrer's code must be 6 characters using only numbers and uppercase letters, and can be changed once every three months."
    ,
    '店铺设置': 'Store Settings'
    ,
    '店铺状态': 'Store Status'
    ,
    '离线': 'Offline'
    ,
    '在线': 'Online'
    ,
    '自动离线': 'Automatic Offline Mode'
    ,
    '开启': 'Enable'
    ,
    '请选择时间': 'Select a time'
    ,
    '店铺（自动）离线后，在售中的饰品将被隐藏且无法购买，直到手动上线。自售功能禁用时，店铺离线且无法手动上线。': 'When your store goes offline, active listings are hidden and cannot be purchased until you bring the store back online. If self-selling is disabled, the store remains offline and cannot be enabled manually.'
    ,
    '店铺修改设置成功': 'Store settings updated.'
    ,
    '您的账号处于暂挂状态，请等待暂挂结束({{date}})再上架店铺': 'Your account is suspended. Wait until the suspension ends ({{date}}) before bringing your store online.'
    ,
    '请先勾选需要改价的物品': 'Select the items whose prices you want to change.'
    ,
    '请先勾选需要下架的物品': 'Select the items you want to delist.'
    ,
    '{{count}} 件': '{{count}} items'
    ,
    '含手续费': 'Including fee'
    ,
    '供应求购': 'Fulfill Buy Order'
    ,
    '(已扣除￥{{fee}}手续费)': '(CNY {{fee}} fee deducted)'
    ,
    '确认供应': 'Confirm Supply'
    ,
    '请前往MOBI APP发送报价': 'Open the MOBI app to send the trade offer.'
    ,
    '取消关注': 'Unfollow Item'
    ,
    '确定要取消关注吗？': 'Are you sure you want to unfollow this item?'
    ,
    '信誉积分变动记录': 'Reputation Score History'
    ,
    '详情': 'Details'
    ,
    '积分变动': 'Score Change'
    ,
    '退款确认': 'Confirm Refund'
    ,
    '您确认要退款？': 'Are you sure you want to request a refund?'
    ,
    '充值订单到账金额为：': 'Amount credited by this deposit: '
    ,
    '您当前所剩余额小于该充值订单金额，您可以选择部分退款': 'Your current balance is lower than this deposit amount. You may request a partial refund.'
    ,
    '(每一笔充值订单仅可退款一次)': '(Each deposit can only be refunded once.)'
    ,
    '(账户余额)': '(Account Balance)'
    ,
    '退款金额为：': 'Refund Amount: '
    ,
    '退款成功': 'Refund successful.'
    ,
    '代币记录': 'Token History'
    ,
    '代币名称': 'Token'
    ,
    '变动数量(个)': 'Change'
    ,
    '变动之前数量(个)': 'Balance Before'
    ,
    '变动之后数量(个)': 'Balance After'
    ,
    '获得时间': 'Time'
    ,
    '一级推广所得': 'Level 1 Referral Reward'
    ,
    '二级推广所得': 'Level 2 Referral Reward'
    ,
    '销售激励所得': 'Sales Incentive'
    ,
    '推广销售激励所得': 'Referral Sales Incentive'
    ,
    '投入Roll房花费': 'Roll Room Entry Cost'
    ,
    '购买激励所得': 'Purchase Incentive'
    ,
    '游戏中检视': 'Inspect in Game'
    ,
    '2D检视图': '2D Inspection'
    ,
    '重新解析': 'Analyze Again'
    ,
    '评论详情': 'Comment Details'
    ,
    '删除': 'Delete'
    ,
    '举报': 'Report'
    ,
    '您确定要': 'Are you sure you want to'
    ,
    '这条评论吗？': 'this comment?'
    ,
    '[图片]': '[Image]'
    ,
    '是否删除该配方？': 'Delete this formula?'
    ,
    '关闭': 'Close'
    ,
    '取消收藏': 'Remove from Favorites'
    ,
    '是否确认取消收藏该配方？': 'Remove this formula from favorites?'
    ,
    '复制': 'Copy'
    ,
    '发布': 'Publish'
    ,
    '取消发布': 'Unpublish'
    ,
    '收藏': 'Favorite'
    ,
    '是否确认复制该配方？': 'Copy this formula?'
    ,
    '是否确认发布配方？': 'Publish this formula?'
    ,
    '是否确认取消发布？': 'Unpublish this formula?'
    ,
    '是否确认收藏该配方？': 'Add this formula to favorites?'
    ,
    '保存配方': 'Save Formula'
    ,
    '保存并发布配方': 'Save and Publish Formula'
    ,
    '当前配方材料少于10件，将会自动保存至草稿配方内！': 'This formula has fewer than 10 materials and will be saved as a draft.'
    ,
    '请输入配方名': 'Enter a formula name'
    ,
    '前往查看': 'View Formula'
    ,
    '重新模拟': 'Simulate Again'
    ,
    '保存配方成功！': 'Formula saved successfully!'
    ,
    '取消回复': 'Cancel Reply'
    ,
    '获取验证码': 'Get Code'
    ,
    '请填写正确的手机验证码！': 'Enter a valid SMS verification code.'
    ,
    '更换手机号': 'Change Phone Number'
    ,
    '45天内最多可更换一次手机号，请勿频繁更换手机号。': 'Your phone number can only be changed once every 45 days.'
    ,
    '您可以在 {{date}} 后再次更换': 'You can change it again after {{date}}.'
    ,
    '更换手机流程仅用于用户本人手机号码变更，原手机及新手机都需要接受短信验证码进行验证，45天内可更换一次': 'This process is only for changing your own phone number. Both the current and new numbers must be verified by SMS, and the number can be changed once every 45 days.'
    ,
    '发送验证码至手机：': 'Send a verification code to:'
    ,
    '发送验证码至新的手机号：': 'Send a verification code to the new number:'
    ,
    '为了您的账号安全，换绑前请先验证身份': 'For account security, verify your identity before changing the number.'
    ,
    '请输入新的手机号': 'Enter a new phone number'
    ,
    '确认绑定': 'Confirm Connection'
    ,
    '更换手机号成功': 'Phone number changed successfully.'
    ,
    '交易消息': 'Trade Messages'
    ,
    '系统消息': 'System Messages'
    ,
    '请前往MOBI APP，使用该功能': 'Please use this feature in the MOBI app.'
    ,
    '当前地区用户暂时无法使用密码登录！': 'Password sign-in is not available in your region at this time.'
    ,
    '请正确输入磨损区间~': 'Enter a valid float range.'
    ,
    '请正确输入价格区间~': 'Enter a valid price range.'
    ,
    '解析超时，请稍后重试': 'Analysis timed out. Please try again later.'
    ,
    '无法解析': 'This item could not be analyzed.'
    ,
    '监视失败': 'Inspection failed.'
    ,
    '监视失败！': 'Inspection failed.'
    ,
    '该物品无法进行汰换！': 'This item cannot be used in a trade-up contract.'
    ,
    '该物品无法用于汰换！': 'This item cannot be used in a trade-up contract.'
    ,
    '最多选择10件物品进行汰换！': 'You can select up to 10 items for a trade-up contract.'
    ,
    '请等待解析完成再进行汰换模拟！': 'Wait for the analysis to finish before running the trade-up simulation.'
    ,
    '选择成功': 'Selected successfully.'
    ,
    '绑定成功！': 'Connected successfully.'
    ,
    '请勿频繁操作！': 'Too many requests. Please try again later.'
    ,
    '请等待物品加载！': 'Wait for the items to finish loading.'
    ,
    '您当页可解析等物品已经解析完毕！': 'All eligible items on this page have already been analyzed.'
    ,
    '解析完成！': 'Analysis complete.'
    ,
    '饰品价格需要大于等于0.02 ！': 'The item price must be at least CNY 0.02.'
    ,
    '饰品价格过大，请重新设置！': 'The item price is too high. Enter a lower price.'
    ,
    '请先勾选物品在进行上架': 'Select the items you want to list first.'
    ,
    '请先完善绑手机绑定和Steam绑定！': 'Connect both your phone number and Steam account first.'
    ,
    '无效的链接！返回至交易市场！': 'Invalid link. Returning to the marketplace.'
    ,
    '取回成功！': 'Item retrieved successfully.'
    ,
    '取回提交成功！': 'Retrieval request submitted successfully.'
    ,
    '请选择供应的饰品!': 'Select the item you want to supply.'
    ,
    '供应成功!': 'Item supplied successfully.'
    ,
    '已终止该求购': 'The buy order has been terminated.'
    ,
    '超出最大供应需求!': 'The selected quantity exceeds the remaining demand.'
    ,
    '购买成功！': 'Purchase successful.'
    ,
    '请在5分钟内前往MOBI APP我的购买发送报价~': 'Open My Purchases in the MOBI app and send the trade offer within 5 minutes.'
    ,
    '请等待卖家发起报价，后续需确认收货~': 'Wait for the seller to send the trade offer, then confirm receipt.'
    ,
    '删除成功！': 'Deleted successfully.'
    ,
    '举报成功！': 'Reported successfully.'
    ,
    '点赞成功': 'Liked.'
    ,
    '取消点赞': 'Like removed.'
    ,
    '请输入评论内容！': 'Enter a comment.'
    ,
    '发布评论成功！': 'Comment posted successfully.'
    ,
    '您只能上传 JPG/PNG 格式的图片!': 'Only JPG and PNG images are supported.'
    ,
    '图片太大，请上传小于10MB的图片!': 'The image is too large. Upload an image smaller than 10 MB.'
    ,
    '必须填入10件饰品，少于10件系统不会生成结果': 'Add 10 items to generate a trade-up result.'
    ,
    '请先在汰换模拟结果中选择一个饰品作为配方的封面': 'Select an item from the simulation results as the formula cover first.'
    ,
    '请输入正确的配方名！': 'Enter a valid formula name.'
    ,
    '请先完善steam绑定！': 'Connect your Steam account first.'
    ,
    '请输入正确的搜索内容！': 'Enter a valid search term.'
    ,
    '加入成功！': 'Joined successfully.'
    ,
    '输入的代币值有误！': 'Enter a valid token amount.'
    ,
    '账户MOE数量不足！': 'Insufficient MOE tokens.'
    ,
    '余额不足！': 'Insufficient balance.'
    ,
    '余额不足，请充值': 'Insufficient balance. Please deposit funds first.'
    ,
    '账户余额不足!': 'Insufficient account balance.'
    ,
    '账户余额不足！': 'Insufficient account balance.'
    ,
    '可提现余额额度不足！': 'Insufficient withdrawable balance.'
    ,
    '系统繁忙，请稍后重试': 'The system is busy. Please try again later.'
    ,
    'steam网络波动，请稍后再试': 'Steam is temporarily unavailable. Please try again later.'
    ,
    'steam网络波动，请稍后再试！': 'Steam is temporarily unavailable. Please try again later.'
    ,
    '操作失败，请尝试重新绑定！': 'The operation failed. Reconnect your Steam account and try again.'
    ,
    '该账号无法绑定Steam账号！': 'This account cannot be connected to Steam.'
    ,
    '用户信息超时或违规操作，请重新点击绑定': 'The connection request expired or is invalid. Start the connection again.'
    ,
    '该steam账号无法绑定网站账户！': 'This Steam account cannot be connected to the website account.'
    ,
    '请通过手机验证码登录才可使用该功能！': 'Sign in with an SMS verification code to use this feature.'
    ,
    '订单不存在': 'The order does not exist.'
    ,
    '该饰品已不在卖家库存，请选择购买其它饰品!': 'This item is no longer in the seller inventory. Choose another item.'
    ,
    '下单失败，请稍后再试！': 'The order could not be placed. Please try again later.'
    ,
    '购买失败！': 'Purchase failed.'
    ,
    '供应失败！': 'Supply failed.'
    ,
    '请勿频繁发送！': 'Too many requests. Please try again later.'
    ,
    '验证码已过期，请重新发送！': 'The verification code has expired. Request a new code.'
    ,
    '验证码有误！': 'The verification code is incorrect.'
    ,
    '提现金额低于单笔最小提现金额': 'The withdrawal amount is below the minimum allowed.'
    ,
    '提现金额高于于单笔最大提现金额': 'The withdrawal amount exceeds the maximum allowed.'
    ,
    '超出当日可提现次数！': 'You have reached today\'s withdrawal limit.'
    ,
    '请尝试重新拖动滑块进行验证！': 'Drag the slider again to complete verification.'
    ,
    '密码太短': 'The password is too short.'
    ,
    '功能正在维护中': 'This feature is currently under maintenance.'
    ,
    '实名认证成功': 'Identity verification completed successfully.'
    ,
    '请将物品解析完毕': 'Finish analyzing the selected items first.'
    ,
    '请选择发起报价方式，如执意不选择发起报价方式，默认为买家发起报价': 'Select who will send the trade offer. If no option is selected, the buyer will send it by default.'
    ,
    '请先绑定 steam 或绑定 steam 交易链接！': 'Connect Steam or add your Steam trade URL first.'
    ,
    '请先设置Steam Api Key！': 'Add your Steam API key first.'
    ,
    '请先完善手机绑定！': 'Connect your phone number first.'
    ,
    '请先绑定 steam 交易链接或Steam Api Key！': 'Add your Steam trade URL and API key first.'
    ,
    '请先绑定 steam 交易链接或 Steam Api Key！': 'Add your Steam trade URL and API key first.'
    ,
    '您当前上架功能受到限制，如需上架请联系客服！': 'Your listing access is restricted. Contact customer support for assistance.'
    ,
    '未查询到此订单': 'The order could not be found.'
    ,
    '请勿频繁上架！': 'You are listing items too frequently. Please try again later.'
    ,
    '参数错误': 'Invalid request parameters.'
    ,
    '参数错误！': 'Invalid request parameters.'
    ,
    '参数有误！': 'Invalid request parameters.'
    ,
    '请先完善用户信息': 'Complete your account information first.'
    ,
    '上架失败，超出了上架最大限额': 'Listing failed because the maximum listing limit was exceeded.'
    ,
    '您上架的物品有部分是已经上架或正在出售！': 'Some selected items are already listed or currently being sold.'
    ,
    '上架物品价格有误！': 'One or more listing prices are invalid.'
    ,
    '含有错误的物品，请加群联系客服！': 'One or more items are invalid. Contact customer support for assistance.'
    ,
    '单价不能小于等于0': 'The unit price must be greater than zero.'
    ,
    '您的报价链接有误或是您的steam账号不能进行交易。': 'Your Steam trade URL is invalid or your Steam account cannot trade.'
    ,
    '请输入整数数量！': 'Enter a whole-number quantity.'
    ,
    '请输入正确求购数量！': 'Enter a valid buy-order quantity.'
    ,
    '错误的物品！': 'Invalid item.'
    ,
    '请勿重复求购该物品！': 'A buy order for this item already exists.'
    ,
    '您有正在被供应中的物品，暂时无法终止求购！': 'This buy order is currently being fulfilled and cannot be terminated.'
    ,
    '请选择正确物品参数': 'Select valid item attributes.'
    ,
    '操作失败': 'Operation failed.'
    ,
    '该类型订单无法取消！': 'This type of order cannot be cancelled.'
    ,
    '暂未绑定网站信息！': 'Connect your website account first.'
    ,
    '该订单已取消': 'This order has been cancelled.'
    ,
    '该订单已发送报价，请勿重复发送！': 'A trade offer has already been sent for this order.'
    ,
    '该订单无法发送报价': 'A trade offer cannot be sent for this order.'
    ,
    '该订单已经无法发送报价，买家正在取消！': 'The buyer is cancelling this order, so a trade offer can no longer be sent.'
    ,
    '该订单已经正在效验，请稍后重试！': 'This order is already being verified. Please try again later.'
    ,
    '错误的订单': 'Invalid order.'
    ,
    '卖家 Api Key 有误': 'The seller\'s Steam API key is invalid.'
    ,
    '暂时无法发送报价': 'Trade offers cannot be sent at this time.'
    ,
    '报价验证码生成失败': 'The trade-offer verification code could not be generated.'
    ,
    '您批量发送的报价订单正在处理中，请稍后再试！': 'Your bulk trade offers are being processed. Please try again later.'
    ,
    '用户需要重新登录steam!': 'Sign in to Steam again in the PZ app.'
    ,
    '该功能两分钟使用一次，请勿频繁发送！': 'This feature can be used once every two minutes.'
    ,
    '卖家的 Steam ApiKey 有误': 'The seller\'s Steam API key is invalid.'
    ,
    'Steam发送交易报价时发生了一个错误。请稍后再试！': 'Steam could not send the trade offer. Please try again later.'
    ,
    '报价发送失败': 'The trade offer could not be sent.'
    ,
    '发送失败': 'The request could not be sent.'
    ,
    '无效报价，请联系管理员': 'The trade offer is invalid. Contact customer support.'
    ,
    '对方交易链接有误': 'The other user\'s Steam trade URL is invalid.'
    ,
    '发送失败，该报价无法手机令牌确认，订单已取消！！': 'Steam Guard could not confirm the trade offer, so the order was cancelled.'
    ,
    '查询报价错误，请检查您的 API KEY 是否正确': 'The trade offer could not be retrieved. Check your Steam API key.'
    ,
    '请使用手机号登录！': 'Sign in with your phone number first.'
    ,
    '无法效验该订单！': 'This order cannot be verified.'
    ,
    '请先绑定您的Steam API Key，即可效验报价': 'Add your Steam API key before verifying the trade offer.'
    ,
    '该订单未到可校验时间！': 'This order is not ready for verification yet.'
    ,
    '该报价必须卖家效验！': 'This trade offer must be verified by the seller.'
    ,
    '效验超时，请稍后重试！': 'Verification timed out. Please try again later.'
    ,
    '效验失败，请重试': 'Verification failed. Please try again.'
    ,
    '效验报价完成！': 'Trade offer verification complete.'
    ,
    '请在steam关闭家庭监护模式，才能使用该功能': 'Disable Steam Family View before using this feature.'
    ,
    '接受成功': 'Trade offer accepted successfully.'
    ,
    'Steam为了保护您库存中的物品，7 天内无法交易。': 'Steam has restricted trading for seven days to protect the items in your inventory.'
    ,
    'Steam接受交易报价时发生了一个错误，请稍后再试。': 'Steam could not accept the trade offer. Please try again later.'
    ,
    '回应失败！': 'The trade offer response failed.'
    ,
    '卖家未绑定Steam！': 'The seller has not connected Steam.'
    ,
    '该物品已被买手购买!': 'This item has already been purchased.'
    ,
    '不能购买自己上架的物品': 'You cannot purchase your own listing.'
    ,
    '购买失败，该物品已下线': 'Purchase failed because this item is no longer listed.'
    ,
    '请选择正确的支付方式': 'Select a valid payment method.'
    ,
    '该饰品在卖家库存中': 'The item is still in the seller\'s inventory.'
    ,
    '无法进行供应！': 'This buy order cannot be fulfilled.'
    ,
    '错误的供应！': 'Invalid supply request.'
    ,
    '超出当前可供应最大限制！': 'The selected quantity exceeds the maximum available demand.'
    ,
    '您供应的物品中有部分是已经在饰品方案中锁定！': 'Some selected items are locked in an item exchange plan.'
    ,
    '请先上线您的店铺！': 'Bring your store online first.'
    ,
    '您的账号已被冻结，无法提现！': 'Your account is frozen and withdrawals are unavailable.'
    ,
    '请完善提现账户信息!': 'Complete your withdrawal account information.'
    ,
    '提现失败！已处理！': 'The withdrawal failed and has been resolved.'
    ,
    '处理中': 'Processing.'
    ,
    '提现失败，请联系客服': 'Withdrawal failed. Contact customer support.'
    ,
    '无效的充值订单！': 'Invalid deposit order.'
    ,
    '退款失败，已超过可退款时间！': 'The refund period for this order has expired.'
    ,
    '请填写正确的退款金额': 'Enter a valid refund amount.'
    ,
    '退款失败，该订单无法退款！': 'This order is not eligible for a refund.'
    ,
    '已退款': 'Refunded.'
    ,
    '充值成功，正在处理！': 'Deposit received and processing.'
};

const normalizeMessageKey = text => text
    .trim()
    .replace(/\s+/g, '')
    .replace(/[。.!！~～]+$/g, '')
    .toLowerCase();

const normalizedEnglishMessages = Object.entries(englishMessages).reduce((messages, [ key, value ]) => {
    const normalizedKey = normalizeMessageKey(key);
    if (! messages[normalizedKey]) messages[normalizedKey] = value;
    return messages;
}, {});

const dynamicEnglishMessages = [
    [ /^至多选择(\d+)件物品上架[！!。]?$/, ([ , count ]) => `You can select up to ${ count } items to list.` ],
    [ /^您的账号处于暂挂状态，请等待暂挂结束\((.+)\)再(?:进行)?上架(?:店铺)?[！!。]?$/, ([ , date ]) => `Your account is suspended. Wait until ${ date } before listing items.` ],
    [ /^您当前只能选择["“](.+)["”]品质的饰品进行汰换模拟[！!。]?$/, ([ , quality ]) => `You can currently select only ${ quality} items for the trade-up simulation.` ],
    [ /^请输入\s*(.+)\s*-\s*(.+)\s*之间的磨损值[！!。]?$/, ([ , min, max ]) => `Enter a float value between ${ min.trim() } and ${ max.trim() }.` ],
    [ /^保存并发布配方成功[！!。]?$/, () => 'Formula saved and published successfully.' ],
    [ /^保存配方成功[！!。]?$/, () => 'Formula saved successfully.' ],
    [ /^取消发布成功[！!。]?$/, () => 'Formula unpublished successfully.' ],
    [ /^发布成功[！!。]?$/, () => 'Published successfully.' ],
    [ /^取消收藏成功[！!。]?$/, () => 'Removed from favorites.' ],
    [ /^收藏成功[！!。]?$/, () => 'Added to favorites.' ],
    [ /^(投入|加入)成功[！!。]?$/, ([ , action ]) => action === '投入' ? 'Tokens added successfully.' : 'Joined successfully.' ],
    [ /^连接出错\((\d+)\)[！!。]?$/, ([ , status ]) => `Connection error (${ status }).` ],
    [ /^求购单价需要大于等于(.+?)[！!。]?$/, ([ , price ]) => `The buy-order unit price must be at least ${ price.trim() }.` ]
];

const fallbackEnglishMessage = text => {
    if (/余额|额度/.test(text) && /(不足|不够)/.test(text)) return 'Insufficient balance.';
    if (/超时|网络波动|网络错误/.test(text)) return 'The request timed out. Please try again later.';
    if (/频繁|次数已达上限|超过限制|超出.*次数/.test(text)) return 'The request limit has been reached. Please try again later.';
    if (/处理中|正在处理|发送中/.test(text)) return 'Your request is being processed.';
    if (/成功|已完成|已保存/.test(text)) return 'Operation completed successfully.';
    if (/验证码/.test(text) && /(有误|错误|无效|过期)/.test(text)) return 'The verification code is invalid or has expired.';
    if (/(参数|格式|信息|链接|ApiKey|API KEY)/i.test(text) && /(有误|错误|无效|不合法|不匹配)/.test(text)) {
        return 'The submitted information is invalid. Check it and try again.';
    }
    if (/请先登录|请登录/.test(text)) return 'Please sign in first.';
    if (/失败|错误|异常|有误|无效|不存在|无法|不能|未能/.test(text)) return 'Unable to complete the operation. Please try again.';
    if (/^请/.test(text)) return 'Check the required information and try again.';
    return 'Unable to complete the operation. Please try again.';
};

export const translateMessage = (text, language = 'zh-CN', values) => {
    if (typeof text !== 'string') return text;
    if (language !== 'en-US') return formatMessage(text, values);
    const templateMessage = englishMessages[text] || normalizedEnglishMessages[normalizeMessageKey(text)];
    if (templateMessage) return formatMessage(templateMessage, values);
    const formattedText = formatMessage(text, values);
    const messageText = formattedText.trim();
    const exactMessage = englishMessages[messageText] || normalizedEnglishMessages[normalizeMessageKey(messageText)];
    if (exactMessage) return exactMessage;
    const dynamicMessage = dynamicEnglishMessages.find(([ pattern ]) => pattern.test(messageText));
    if (dynamicMessage) return dynamicMessage[1](messageText.match(dynamicMessage[0]));
    return formattedText;
};

export const translatePopupMessage = (text, language = 'zh-CN', values) => {
    const translatedText = translateMessage(text, language, values);
    if (language !== 'en-US' || typeof translatedText !== 'string') return translatedText;
    return /[\u3400-\u9fff]/.test(translatedText) ? fallbackEnglishMessage(translatedText) : translatedText;
};

const I18nContext = createContext({
    language: 'zh-CN',
    setLanguage: () => {},
    t: text => text,
    itemName: item => item?.market_name || item?.market_hash_name || item?.name || ''
});

const formatMessage = (message, values = {}) => Object.keys(values).reduce(
    (result, key) => result.replace(new RegExp(`{{${ key }}}`, 'g'), values[key]),
    message
);

export function I18nProvider({ children }) {
    const [ language, setLanguageState ] = useState(() => localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en-US');
    const setLanguage = nextLanguage => {
        const normalizedLanguage = nextLanguage === 'en-US' ? 'en-US' : 'zh-CN';
        localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
        setLanguageState(normalizedLanguage);
    };
    const value = useMemo(() => ({
        language,
        setLanguage,
        t: (text, values) => translateMessage(text, language, values),
        itemName: item => language === 'en-US'
            ? item?.market_hash_name || item?.en_name || item?.market_name || item?.name || ''
            : item?.market_name || item?.name || item?.market_hash_name || '',
        localizedField: (record, field) => language === 'en-US'
            ? record?.[`${ field }_en`] || record?.[`en_${ field }`] || record?.[`${ field }En`] || record?.[field]
            : record?.[field]
    }), [ language ]);
    
    useEffect(() => {
        document.documentElement.lang = language;
    }, [ language ]);
    
    return <I18nContext.Provider value={ value }>
        <ConfigProvider locale={ language === 'en-US' ? enUS : zhCN }>
            { children }
        </ConfigProvider>
    </I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
export const withI18n = WrappedComponent => props => {
    const i18n = useI18n();
    return <WrappedComponent { ...props } i18n={ i18n }/>;
};
export const getCurrentLanguage = () => localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'en-US' ? 'en-US' : 'zh-CN';

let messageLocalizationInstalled = false;

export const installMessageLocalization = () => {
    if (messageLocalizationInstalled) return;
    messageLocalizationInstalled = true;
    [ 'success', 'error', 'warning', 'info', 'loading' ].forEach(method => {
        const original = antdMessage[method].bind(antdMessage);
        antdMessage[method] = (content, ...args) => {
            const localizedContent = typeof content === 'string'
                ? translatePopupMessage(content, getCurrentLanguage())
                : content && typeof content === 'object' && typeof content.content === 'string'
                    ? { ...content, content: translatePopupMessage(content.content, getCurrentLanguage()) }
                    : content;
            return original(localizedContent, ...args);
        };
    });
};

installMessageLocalization();
